import React, { useState } from "react";
import { Container, Row, Col } from "react-bootstrap";
import { Route, Routes } from "react-router-dom";
import HelpSidebar from "./HelpSidebar";
import HelpSearch from "./HelpSearch";
import Title from "../common/Title";
import { FaQuestionCircle } from "react-icons/fa";

// Import help topic components
import GettingStarted from "./topics/GettingStarted";
import Dashboard from "./topics/Dashboard";
import RunbooksOverview from "./topics/RunbooksOverview";
import CreatingRunbooks from "./topics/CreatingRunbooks";
import ExecutingRunbooks from "./topics/ExecutingRunbooks";
import WorkflowBuilder from "./topics/WorkflowBuilder";
import SchedulersOverview from "./topics/SchedulersOverview";
import CreatingSchedules from "./topics/CreatingSchedules";
import VariablesOverview from "./topics/VariablesOverview";
import ManagingVariables from "./topics/ManagingVariables";
import ConnectorsOverview from "./topics/ConnectorsOverview";
import ManagingConnectors from "./topics/ManagingConnectors";
import UserManagement from "./topics/UserManagement";
import Invitations from "./topics/Invitations";
import PermissionGroupsOverview from "./topics/PermissionGroupsOverview";
import CreatingPermissionGroups from "./topics/CreatingPermissionGroups";
import AssigningPermissions from "./topics/AssigningPermissions";
import ManagingGroupMembers from "./topics/ManagingGroupMembers";
import AssigningRunbooksToGroups from "./topics/AssigningRunbooksToGroups";
import PermissionLookups from "./topics/PermissionLookups";
import AuditLog from "./topics/AuditLog";
import HelpHome from "./HelpHome";

function HelpLayout({ user }) {
  const [searchQuery, setSearchQuery] = useState("");

  return (
    <>
      <Title text="Help Center" icon={<FaQuestionCircle className="mb-1" />} />

      <Container fluid>
        <Row>
          <Col md={3} className="mb-4">
            <HelpSidebar user={user} searchQuery={searchQuery} />
          </Col>
          <Col md={9}>
            <HelpSearch searchQuery={searchQuery} setSearchQuery={setSearchQuery} />

            <div className="help-content mt-4">
              <Routes>
                <Route index element={<HelpHome searchQuery={searchQuery} user={user} />} />
                <Route path="getting-started" element={<GettingStarted />} />
                <Route path="dashboard" element={<Dashboard />} />
                <Route path="runbooks-overview" element={<RunbooksOverview />} />
                <Route path="creating-runbooks" element={<CreatingRunbooks />} />
                <Route path="executing-runbooks" element={<ExecutingRunbooks />} />
                <Route path="workflow-builder" element={<WorkflowBuilder />} />
                <Route path="schedulers-overview" element={<SchedulersOverview />} />
                <Route path="creating-schedules" element={<CreatingSchedules />} />
                <Route path="variables-overview" element={<VariablesOverview />} />
                <Route path="managing-variables" element={<ManagingVariables />} />
                <Route path="connectors-overview" element={<ConnectorsOverview />} />
                <Route path="managing-connectors" element={<ManagingConnectors />} />
                <Route path="user-management" element={<UserManagement />} />
                <Route path="invitations" element={<Invitations />} />
                <Route path="permission-groups-overview" element={<PermissionGroupsOverview />} />
                <Route path="creating-permission-groups" element={<CreatingPermissionGroups />} />
                <Route path="assigning-permissions" element={<AssigningPermissions />} />
                <Route path="managing-group-members" element={<ManagingGroupMembers />} />
                <Route path="assigning-runbooks-to-groups" element={<AssigningRunbooksToGroups />} />
                <Route path="permission-lookups" element={<PermissionLookups />} />
                <Route path="audit-log" element={<AuditLog />} />
              </Routes>
            </div>
          </Col>
        </Row>
      </Container>
    </>
  );
}

export default HelpLayout;
